import { Typography, Button, Select, MenuItem } from "@mui/material";
import { Box } from "@mui/system";

import useTranslation from "shared/helpers/hooks/useTranslation";
import { useState } from "react";

const StatusSelect = ({
    onSave,
}) => {
    const t = useTranslation();
    const [status, setStatus] = useState<string>("1");

    return (
        <Box display={"flex"} gap={2}>
            <Select
                size="small"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                sx={{ minWidth: 180, backgroundColor: '#f8f9fa' }}
            >
                <MenuItem value="1">Active</MenuItem>
                <MenuItem value="2">Blocked</MenuItem>
                <MenuItem value="3">Quarantined</MenuItem>
            </Select>

            <Button
                variant="contained"
                onClick={() => onSave?.(status)}
            >
                <Typography>{t("save")}</Typography>
            </Button>


        </Box>
    );
};

export default StatusSelect;
